<template>
  <sidebar
    :title="`Bundle Details #${selectedProductBundle.bundleID}`"
    :show="showBundleSidebar"
    @on-close="close"
    size="md"
  >
    <template v-slot:body>
      <div>
        <div class="bundle-right-container">
          <div v-if="selectedProductBundle && selectedProductBundle.products">
            <div
              class="bundle-item"
              :class="
                product.isSuccess
                  ? 'bundle-border-success'
                  : 'bundle-border-failed'
              "
              v-for="(product, index) in selectedProductBundle.products"
              :key="product.productID"
            >
              <div class="d-flex justify-content-between align-items-center">
                <!-- Left side (Category, Family, Offer) -->
                <div class="ms-2 me-2 bundle-description-view">
                  <small>{{ product.brand }}</small>
                  <h6 class="mb-0">{{ product.family }}</h6>
                  <small>{{ product.offer }}</small>
                </div>

                <!-- Description -->
                <div class="ms-2 me-2 bundle-description-view">
                  <small>{{ product.description }}</small>
                </div>

                <!-- Price -->
                <div style="width: 200px" class="text-end pe-3">
                  <span class="badge badge-sm bg-gradient-bundle">
                    Php {{ product.srp.toLocaleString() }}
                  </span>
                </div>

                <!-- Status -->
                <div
                  class="ms-2 me-2 d-flex align-items-center"
                  :class="
                    product.isSuccess
                      ? 'bundle-status-success'
                      : 'bundle-status-failed'
                  "
                >
                  <img
                    :src="
                      product.isSuccess ? 'img/success.png' : 'img/error.png'
                    "
                    alt="Status Icon"
                    class="me-2"
                    style="width: 30px; height: 30px"
                  />
                  <span class="fw-bold">
                    {{ product.isSuccess ? "Success" : "Failed" }}
                  </span>
                </div>
              </div>
              <div v-if="!product.isSuccess && product.particulars" class="m-2">
                <hr class="horizontal dark mt-0 mb-2" />
                <div>
                  <small>Reason: {{ product.particulars }}</small>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- <hr class="horizontal dark"> -->
        <div class="card-new mt-4" style="width: 100%">
          <div class="row mt-3">
            <div class="col">
              <div class="form-group">
                <label class="mb-0 fw-bold">
                  <i class="fa-solid fa-layer-group me-1 text-success"></i>
                  Bundle Name</label
                >
                <div class="mb-3">
                  <label class="mb-0 ms-4">
                    {{ selectedProductBundle.bundleName }}</label
                  >
                </div>
              </div>
            </div>

            <div class="col">
              <div class="form-group">
                <label class="mb-0 fw-bold">
                  <i class="fa-solid fa-tags me-1 text-danger"></i>
                  SRP</label
                >
                <div class="mb-3">
                  <label class="mb-0 ms-4">
                    Php {{ selectedProductBundle.bundleSRP }}</label
                  >
                </div>
              </div>
            </div>
            <div class="col">
              <div class="form-group">
                <label class="mb-0 fw-bold">
                  <i class="fa-solid fa-table-list me-1 text-warning"></i
                  >Category</label
                >
                <div class="mb-3">
                  <label class="mb-0 ms-4">
                    {{ selectedProductBundle.bundleCategory }}</label
                  >
                </div>
              </div>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col">
              <div class="form-group">
                <label class="mb-0 fw-bold">
                  <i class="fa-regular fa-comment me-1 text-info"></i>
                  Description</label
                >
                <div class="mb-3">
                  <label class="mb-0 ms-4">
                    {{ selectedProductBundle.bundleDescription }}
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </sidebar>
</template>

<script>
import sidebar from "./../../../../components/sidebar.vue";
import { mapActions, mapMutations, mapState } from "vuex";

export default {
  components: {
    sidebar,
  },

  methods: {
    ...mapMutations({
      setShowSettingsSidebar: "retailerController/SET_ShowBundleSidebar",
      selectProductBundle: "productController/SELECT_ProductBundle",
    }),

    close() {
      this.setShowSettingsSidebar(false);
        this.selectProductBundle(null);
        this.$emit("clear-selection");
    },
  },
  computed: {
    ...mapState({
      showBundleSidebar: (state) => state.retailerController.showBundleSidebar,
      selectedProductBundle: (state) => state.productController.productBundle,
    }),
  },
};
</script>

<style></style>
